import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-slides',
  templateUrl: './slides.component.html',
  styleUrls: ['./slides.component.scss']
})
export class SlidesComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = BOOK_STORE_TABS.SLIDES;
  DISPLAY_STATUS_KEY: any;
  TITLE:any="Slide"
  COLLECTION:any=COLLECTION_NAME.BOOK_STORE_SLIDES;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: BookstoreStore,
    private dialog:MatDialog,
    private storage:FireStorageService,
    private snackBar:MatSnackBar,
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(async (param) => {
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT[param['id']];
      this.store.fetchData(COLLECTION_NAME.BOOK_STORE_SLIDES, this.DISPLAY_STATUS_KEY.key)
    })
  }

  create() {
    this.router.navigate([`/book-store/slides/slide-form/draft`])
  }
  
  edit(item: any) {
    this.router.navigate([`/book-store/slides/slide-form/${item.key}`])
  }

  delete(item: any) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: {
        title: `Delete ${this.TITLE}`,
        memo: `${this.TITLE} will permanently drop from app.`,
        name: item.name,
        button: "OK",
      },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      disableClose: true,
      role: 'dialog'
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'yes') {
        if(item.coverFileDetail){
          await this.storage.storageRef(item.coverFileDetail.filename).delete().toPromise();
        }
        this.store.deleteItem(this.COLLECTION, item, (success, error) => {
          if (success) {
            this.snackBar.open(`${this.TITLE} has been deleted.`, 'done', { duration: 2000 });
            this.store.fetchData(this.COLLECTION, this.DISPLAY_STATUS_KEY.key)
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }
}
